import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Zap } from 'lucide-react';
import { LegalModal } from './LegalModal';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalClose() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer id="pricing" className="w-full bg-navy text-cream pt-20 pb-12 px-6 mt-12" data-id="element-40">
        <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-41">
          <h2 className="text-3xl md:text-5xl font-serif font-bold leading-tight" data-id="element-42">
            No necesitas "otra idea".
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto" data-id="element-43">
            Necesitas un sistema que te quite el peso de encima.
          </p>

          <p className="text-lg text-teal font-medium italic" data-id="element-44">
            Planeación 10X: para que tus clases salgan mejor… sin que tu vida se
            vaya en planearlas.
          </p>

          {/* Pricing Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="relative bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 md:p-12 max-w-lg mx-auto mt-8" data-id="element-45">
            {/* Discount Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-46">
              <span className="bg-teal text-navy font-bold text-sm px-4 py-1.5 rounded-full flex items-center gap-1.5 shadow-lg" data-id="element-47">
                <Zap className="w-4 h-4" data-id="element-48" />
                40% DE DESCUENTO
              </span>
            </div>

            <div className="space-y-6 pt-4" data-id="element-49">
              <h3 className="text-2xl font-serif font-bold text-white" data-id="element-50">
                Planeación 10X
              </h3>

              {/* Price */}
              <div className="flex items-center justify-center gap-4" data-id="element-51">
                <span className="text-xl text-gray-400 line-through" data-id="element-52">
                  $499 MXN
                </span>
                <span className="text-5xl md:text-6xl font-black text-white" data-id="element-53">
                  $299
                </span>
                <span className="text-lg text-gray-300 self-end mb-1" data-id="element-54">MXN</span>
              </div>

              <p className="text-sm text-teal" data-id="element-55">Pago único — acceso inmediato</p>

              {/* CTA Button */}
              <motion.a href="https://tuordendigital.com/cart/42063398273070:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="w-full bg-amber text-navy font-bold text-lg md:text-xl px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center gap-2" data-id="element-56">
                COMPRAR AHORA — $299 MXN
                <ShoppingCart className="w-5 h-5" data-id="element-57" />
              </motion.a>

              <p className="text-xs text-gray-400" data-id="element-58">
                Garantía de satisfacción — si no te funciona, pides reembolso
                sin peleas.
              </p>

              {/* What you get */}
              <div className="border-t border-white/10 pt-6 space-y-3 text-left" data-id="element-59">
                <p className="text-xs uppercase tracking-widest text-gray-400 mb-3" data-id="element-60">
                  Incluye:
                </p>
                {['Sistema completo Mapa 3C + Bloque 7', 'Protocolo de planeación en 15 minutos', '12 ganchos + Micro-modelos M4', 'Banco de evidencias + Rúbrica de 4 puntos', 'Plantillas editables (Google Docs/Slides)'].map((item, i) => <p key={i} className="text-sm text-gray-300 flex items-start gap-2" data-id="element-61">
                    <span className="text-teal mt-0.5" data-id="element-62">✓</span>
                    {item}
                  </p>)}
              </div>
            </div>
          </motion.div>

          <div className="pt-12 border-t border-white/10 text-sm text-gray-400" data-id="element-63">
            <p data-id="element-64">
              © {new Date().getFullYear()} Planeación 10X. Todos los derechos
              reservados.
            </p>
            <div className="flex items-center justify-center gap-4 mt-3" data-id="element-65">
              <button onClick={() => setShowPrivacy(true)} className="underline underline-offset-2 hover:text-teal transition-colors" data-id="element-66">
                Política de Privacidad
              </button>
              <span className="text-gray-600" data-id="element-67">•</span>
              <button onClick={() => setShowTerms(true)} className="underline underline-offset-2 hover:text-teal transition-colors" data-id="element-68">
                Términos de Servicio
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-69">
        <p className="font-bold" data-id="element-70">Última actualización: Febrero 2026</p>

        <p data-id="element-71">
          En Planeación 10X, respetamos tu privacidad y nos comprometemos a
          proteger tus datos personales. Esta política describe cómo
          recopilamos, usamos y protegemos tu información.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-72">
          1. Información que recopilamos
        </h3>
        <p data-id="element-73">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-74">
          <li data-id="element-75">Nombre completo</li>
          <li data-id="element-76">Correo electrónico</li>
          <li data-id="element-77">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
        </ul>

        <h3 className="font-bold text-navy mt-4" data-id="element-78">2. Uso de la información</h3>
        <p data-id="element-79">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-80">
          <li data-id="element-81">Procesar y entregar tu compra</li>
          <li data-id="element-82">Enviarte el producto y actualizaciones relacionadas</li>
          <li data-id="element-83">Atender solicitudes de soporte o reembolso</li>
        </ul>

        <h3 className="font-bold text-navy mt-4" data-id="element-84">3. Protección de datos</h3>
        <p data-id="element-85">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros. Utilizamos medidas de seguridad estándar de la industria
          para proteger tus datos.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-86">4. Cookies</h3>
        <p data-id="element-87">
          Utilizamos cookies básicas para mejorar tu experiencia de navegación y
          analizar el tráfico del sitio. No utilizamos cookies de seguimiento
          publicitario.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-88">5. Tus derechos</h3>
        <p data-id="element-89">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-90">6. Contacto</h3>
        <p data-id="element-91">
          Si tienes preguntas sobre esta política, escríbenos a:{' '}
          <span className="font-semibold" data-id="element-92">contacto@planeacion10x.com</span>
        </p>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos de Servicio" data-id="element-93">
        <p className="font-bold" data-id="element-94">Última actualización: Febrero 2026</p>

        <p data-id="element-95">
          Al adquirir Planeación 10X, aceptas los siguientes términos y
          condiciones de uso.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-96">1. Producto digital</h3>
        <p data-id="element-97">
          Planeación 10X es un producto digital que incluye un PDF y plantillas
          editables en Google Docs/Slides. Al completar tu compra, recibirás
          acceso inmediato al material.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-98">2. Licencia de uso</h3>
        <p data-id="element-99">
          La compra te otorga una licencia personal e intransferible para usar
          el material en tu práctica docente. Queda prohibido:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-100">
          <li data-id="element-101">Redistribuir, revender o compartir el material con terceros</li>
          <li data-id="element-102">Publicar el contenido en plataformas públicas</li>
          <li data-id="element-103">
            Usar el material con fines comerciales distintos a tu práctica
            docente
          </li>
        </ul>

        <h3 className="font-bold text-navy mt-4" data-id="element-104">
          3. Garantía de satisfacción
        </h3>
        <p data-id="element-105">
          Si aplicas el sistema en tu próxima planeación y sientes que no te
          ahorró tiempo o no te dio más claridad, puedes solicitar un reembolso
          completo. El plazo para solicitar reembolso es de 30 días a partir de
          la fecha de compra.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-106">4. Propiedad intelectual</h3>
        <p data-id="element-107">
          Todo el contenido de Planeación 10X (textos, diseños, metodología,
          plantillas) es propiedad intelectual protegida. La compra no
          transfiere derechos de propiedad intelectual.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-108">
          5. Limitación de responsabilidad
        </h3>
        <p data-id="element-109">
          Planeación 10X es una herramienta de apoyo para la planeación docente.
          Los resultados pueden variar según el contexto, la materia y la
          aplicación individual del sistema.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-110">6. Modificaciones</h3>
        <p data-id="element-111">
          Nos reservamos el derecho de actualizar estos términos. Los cambios
          serán notificados por correo electrónico a los compradores
          registrados.
        </p>

        <h3 className="font-bold text-navy mt-4" data-id="element-112">7. Contacto</h3>
        <p data-id="element-113">
          Para cualquier duda sobre estos términos:{' '}
          <span className="font-semibold" data-id="element-114">contacto@planeacion10x.com</span>
        </p>
      </LegalModal>
    </>;
}